/* eslint-disable react/prop-types */
import React from 'react';
import OmrSymbol from './OmrSymbol';

export function formatOmrDigits(value, decimals = 3) {
  if (value == null || value === '') return `0.${'0'.repeat(decimals)}`;
  const num = Number(value);
  return Number.isNaN(num) ? `0.${'0'.repeat(decimals)}` : num.toFixed(decimals);
}

/**
 * Amount + Omani Rial symbol (replaces “123.456 OMR” text).
 * If `empty` is set and value is missing, shows `empty` only.
 * If `empty` is omitted, missing value is shown as 0.000 + symbol (legacy formatCurrencyOMR behavior).
 */
export function OmrAmount({ value, decimals = 3, empty }) {
  if (empty !== undefined && (value == null || value === '')) {
    return empty;
  }
  const num = value == null || value === '' ? 0 : Number(value);
  const text = Number.isNaN(num) ? `0.${'0'.repeat(decimals)}` : num.toFixed(decimals);
  return (
    <>
      {text}{' '}
      <OmrSymbol height={14} />
    </>
  );
}
